import { Injectable } from '@angular/core';
import { FormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { getDefaultControlValue } from '@gk/gk-modules';
import { ECSControlName } from '../../../../components/electronic-correspondence-statement/models/form/form.model';
import { BaseNewRequestFormService } from '../../../../shared/base-new-request-form/base-new-request-form.service';
import {
  HSTNNewRequestControlName,
  HSTNNewRequestFormGroup,
} from './new-request-form.model';

@Injectable()
export class HSTNNewRequestFormService {
  constructor(
    private formBuilder: UntypedFormBuilder,
    private baseNewRequestFormService: BaseNewRequestFormService,
  ) {}

  getFormGroup(): FormGroup<HSTNNewRequestFormGroup> {
    return this.formBuilder.group({
      ...this.baseNewRequestFormService.getCommonInvestorFormGroup(
        {
          [ECSControlName.ElectronicCorrespondenceStatement]: false,
        },
        {
          addressFormGroupBasedOnSelectControls: true,
          disableAddressFormInNaturalPersonGroup: true,
        },
      ).controls,
      [HSTNNewRequestControlName.ActivityDescription]: this.formBuilder.control(
        getDefaultControlValue(),
        Validators.required,
      ),
      [HSTNNewRequestControlName.InstallationOperatingTime]:
        this.formBuilder.control(getDefaultControlValue(), Validators.required),
      [HSTNNewRequestControlName.EmissionTypeAndAmount]:
        this.formBuilder.control(getDefaultControlValue(), Validators.required),
      [HSTNNewRequestControlName.EmissionReductionMethods]:
        this.formBuilder.control(getDefaultControlValue(), Validators.required),
      [HSTNNewRequestControlName.ReductionCompliantDescription]:
        this.formBuilder.control(getDefaultControlValue(), Validators.required),
    });
  }
}
